module.exports = __webpack_public_path__ + "images/tick-whited7ac94d609a404383c354fb2f2d20f3d.png";